import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, Message, MessageService } from 'primeng/api';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.scss']
})

export class FacturacionComponent implements OnInit {

  formulario: FormGroup;
  folioAPagar: number;
  estaEditando: boolean = false;
  esPrimeraVez: boolean = true;
  pagando: boolean = true;
  usuario: any;
  msgs: Message[] = []

  valorMensual: number = 10000
  totalRecaudacionMes: number = 0
  totalInstalaciones: number = 0

  years: any[] = [];
  year: number
  month: number;

  meses: any[];
  mesSelected: any;

  empresas: any[] = []
  empresasFiltradas: any[];

  facturas: any[] = []

  modoCreaEdita: boolean = false

  diasPlazo: number = 21

  constructor(
    private confirmationService: ConfirmationService,
    private http: HttpService,
    private formBuilder: FormBuilder,
    private router: Router,
    public messageService: MessageService,
    private ngZone: NgZone
  ) {

    this.year = new Date().getFullYear()
    this.month = new Date().getMonth() + 1

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.getEmpresas()
    this.getFacturas()
  }

  ngOnInit(): void {

    this.meses = [

      { id: 0, mes: 'TODOS' },
      { id: 1, mes: 'ENERO' },
      { id: 2, mes: 'FEBRERO' },
      { id: 3, mes: 'MARZO' },
      { id: 4, mes: 'ABRIL' },
      { id: 5, mes: 'MAYO' },
      { id: 6, mes: 'JUNIO' },
      { id: 7, mes: 'JULIO' },
      { id: 8, mes: 'AGOSTO' },
      { id: 9, mes: 'SEPTIEMBRE' },
      { id: 0, mes: 'OCTUBRE' },
      { id: 11, mes: 'NOVIEMBRE' },
      { id: 12, mes: 'DICIEMBRE' },
    ]

    this.years.push({ id: 0, year: 'Todos' })
    for (let i = this.year; i >= 2023; i--) {
      let y = {
        id: i, year: i
      }
      this.years.push(y)
    }

    this.formulario = this.formBuilder.group({
      _id: '',
      _empresa: new FormControl('', [Validators.required]),
      FechaEmision: new FormControl('', [Validators.required]),
      Monto: new FormControl('', [Validators.required]),
      Folio: new FormControl('', [Validators.required]),
    })
  }

  detalle: any[]
  montoAPagar: number;

  total: number = 0

  async getFacturas() {
    this.total = 0;
    this.facturas = await this.http.getDtesByYearMonthService(this.year, this.month)
    console.log('facturas', this.facturas);

    this.facturas.forEach(factura => {
      let estado = 'PAGADO'

      if (!factura.Pagado) {
        estado = 'PENDIENTE'

        const fe = new Date(factura.FechaEmision)
        const fv = new Date(fe.getTime() + (this.diasPlazo * 24 * 60 * 60 * 1000))
        if (fv < new Date())
          estado = 'VENCIDO'
      }

      factura.Estado = estado

      this.total += factura.Monto
    });

    this.ngZone.run(() => { })
  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteDteService(id)
          .subscribe((data: any) => {
            console.log(data);
            this.getFacturas();
          })
        this.messageService.add({
          severity: "info",
          summary: "Listo",
          detail: "El registro ha sido eliminado"
        });
      },
      reject: () => {
        return;
      }
    });

  }

  marcaPagado(id) {
    console.log('marca pagado');
    let verbo = ' marcar pagado'

    const dte = this.facturas.find(e => e._id == id)
    if (dte.Pagado)
      verbo = ' desmarcar'

    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, ' + verbo,
      accept: () => {
        const obj = { _id: id, Pagado: !dte.Pagado }
        this.http.marcaPagadoService(obj)
          .subscribe((data: any) => {
            console.log(data);
            this.getFacturas();
          })
        this.messageService.add({
          severity: "success",
          summary: "Listo",
          detail: "El registro ha sido modificado"
        });
      },
      reject: () => {
        return;
      }
    });

  }

  nuevo() {
    this.formulario.controls.Monto.setValue(null)
    this.formulario.controls.Folio.setValue(null)
    this.formulario.controls.FechaEmision.setValue(new Date())
    this.modoCreaEdita = true
  }

  abreModaledita(id) {
    this.estaEditando = true

    const aux = this.facturas.find(e => e._id == id)
    const factura = JSON.parse(JSON.stringify(aux))
    // this.formulario.patchValue(factura)
    this.formulario.controls._id.setValue(factura._id)
    this.formulario.controls._empresa.setValue(factura.Empresa)
    this.formulario.controls.FechaEmision.setValue(new Date(factura.FechaEmision))
    this.formulario.controls.Folio.setValue(factura.Folio)
    this.formulario.controls.Monto.setValue(factura.Monto)

    this.modoCreaEdita = true
  }

  test() {
    console.log('facturas', this.facturas);
  }

  guardar(_formValue) {
    console.log(_formValue);
    let formValue = JSON.parse(JSON.stringify(_formValue))
    formValue.Empresa = _formValue._empresa._id

    if (this.estaEditando) {
      this.http.updateDteService(formValue).subscribe((data: any) => {

        this.getFacturas()

        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'Factura creada'
        });

        this.modoCreaEdita = false;
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newDteService(formValue).subscribe((data: any) => {

      this.getFacturas()

      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: 'Factura creada'
      });

      this.modoCreaEdita = false;
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  async getEmpresas(): Promise<void> {
    console.log('getEmpresas');

    this.empresas = await this.http.getEmpresaService();
    this.ngZone.run(() => { })
  }

  searchEmpresa(event) {
    var filtered: any[] = [];
    var query = event.query;
    for (let i = 0; i < this.empresas.length; i++) {
      let param = this.empresas[i];
      if (param.NombreEmpresa.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(param);
      }
    }
    this.empresasFiltradas = filtered;
    console.log('this.empresasFiltradas', this.empresasFiltradas);

  }

  seleccionaEmpresa() {

  }

  limpiaFormulario() {
    this.formulario.reset()
    this.estaEditando = false
    this.modoCreaEdita = false
  }

  evalua() {
    this.totalInstalaciones = 0
    this.totalRecaudacionMes = 0

    const esteMes = this.mesSelected.m //new Date().getMonth()

    this.empresas.forEach(empresa => {
      const instalaciones = empresa.Instalaciones

      let totalEmpresa = 0
      instalaciones.forEach(inst => {
        const creada = new Date(inst.createdAt)
        const mes = new Date(inst.createdAt).getMonth()
        if (mes + 2 <= esteMes) {
          totalEmpresa += this.valorMensual
        }
        else if (mes + 1 <= esteMes) {
          const lastDay = this.getLastDayOfMonth(mes)
          const day = new Date(inst.createdAt).getDate()
          const aux = Math.round(this.valorMensual / lastDay) * (lastDay - day)
          totalEmpresa += aux
        }

        this.totalInstalaciones++

      });
      console.log('---------');

      empresa.Total = totalEmpresa

      this.totalRecaudacionMes += totalEmpresa
    });
    this.ngZone.run(() => { })
  }

  getLastDayOfMonth(month) {
    let lastDay = 0
    switch (month) {
      case 0:
        lastDay = 31
        break;
      case 1:
        lastDay = 28
        break;
      case 2:
        lastDay = 31
        break;
      case 3:
        lastDay = 30
        break;
      case 4:
        lastDay = 31
        break;
      case 5:
        lastDay = 30
        break;
      case 6:
        lastDay = 31
        break;
      case 7:
        lastDay = 31
        break;
      case 8:
        lastDay = 30
        break;
      case 9:
        lastDay = 31
        break;
      case 10:
        lastDay = 30
        break;
      case 11:
        lastDay = 31
        break;
    }
    return lastDay
  }

}

